<template>
	<div class="container">
    <div class="header">请完成实名认证后进行使用</div>
    <div class="content">
      <div class="item" @click="selectCardType">
        <div class="txt"><span>*</span>证件类型</div>
        <div class="value">{{typeLabel}}</div>
      </div>
      <div class="item-verify-side">
        <div class="txt"><span>*</span>身份证人面像</div>
        <div class="collect-box">
          <el-image class="collect-box-image" :src="rightSideUrl || require('@/assets/images/icon-right-side.png')" />
          <div class="collect-box-btn" @click="toCollect('front')">点击采集</div>
        </div>
      </div>
      <div class="item-verify-side">
        <div class="txt"><span>*</span>身份证国徽面</div>
        <div class="collect-box">
          <el-image class="collect-box-image" :src="reverseSideUrl || require('@/assets/images/icon-reverse-side.png')" />
          <div class="collect-box-btn" @click="toCollect('back')">点击采集</div>
        </div>
      </div>
      <div class="collect-item">
        <div class="txt"><span>*</span>姓名</div>
        <div :class="userIdcardInfo.name==='根据认证信息自动读取'?'default':'value'">{{userIdcardInfo.name}}</div>
      </div>
      <div class="collect-item">
        <div class="txt"><span>*</span>身份证号</div>
        <div :class="userIdcardInfo.idCardNum==='根据认证信息自动读取'?'default':'value'">{{userIdcardInfo.idCardNum}}</div>
      </div>
      <div class="collect-item">
        <div class="txt"><span>*</span>手机号</div>
        <el-input class="phone" v-model="phone" placeholder="请输入手机号"></el-input>
      </div>
      <div class="item" @click="faceCollection">
        <div class="txt"><span>*</span>人脸采集</div>
        <div class="value" style="color: #6f737f">{{faceCollectLabel}}</div>
      </div>
      <div class="verify-btn" @click="toFace">提交核验</div>
    </div>
    <!-- <el-drawer
      title=""
      :with-header="false"
      :visible.sync="drawer"
      direction="btt"
      custom-class="drawerStyle"
      :before-close="handleClose">
      <div class="camera-box">
        <div class="camera-box-item" @click="takeCamera">拍照</div>
        <div class="camera-box-item" @click="takeFile">本地图片</div>
      </div>
    </el-drawer> -->
    <el-drawer
      title=""
      :with-header="false"
      :visible.sync="cardTypeShow"
      direction="btt"
      custom-class="cardTypeStyle"
      :before-close="handleClose">
      <div class="camera-box">
        <div class="camera-box-item" v-for="item in cardTypeArr" :key="item.value" @click="takeIdCard(item)">{{item.label}}</div>
      </div>
    </el-drawer>
    <!-- <video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay style="display: none;"></video>  
    <canvas id="canvasCamera" :width="videoWidth" :height="videoHeight" style="display: none;"></canvas> -->
    <input class="hide_file" ref="leftFile" id="upload" type="file" @change="getFile($event)" accept="image/*" style="display: none;" />
    <input class="hide_file" ref="faceFile" id="upload" type="file" @change="getFile($event)" accept="image/*" capture="camera" style="display: none;" />
	</div>
</template>
  
<script>
import wx from "weixin-js-sdk";
import { uploadFile } from "@/utils/fileUpload.js";
import { gethwtoken, hwLiveDetectFace, matchFaceApi, uploadBase64ImgToV5Api, confirmCheckStatus, uploadFileToV5Api, getBaiduFace, getBaiduIdcard, getBaiduResultSimple, getBaiduFaceDetail } from "@/api/common";

  export default {
    name: 'Face',
    data() {
      return {
        token: '',
        areaCode: '',
        credentialType: '',
        domainId: '',
        obsFilePath: '',
        faceCollectLabel: '未采集',
        videoWidth: 640,
        videoHeight: 480,
        typeLabel: '',
        idCardType: '',
        rightSideUrl: '',
        reverseSideUrl: '',
        drawer: false,
        cardTypeShow: false,
        userIdcardInfo: {
          name: '根据认证信息自动读取',
          idCardNum: '根据认证信息自动读取',
          address: '',
          validDateFrom: '',
          validDateTo: ''
        },
        phone: '',
        cardTypeArr: [
          {
						label: "居民身份证（户口簿）",
						value: "IdCard",
					},
					{
						label: "香港特区护照/身份证明",
						value: "IdCardOfXiangGang",
					},
					{
						label: "澳门特区护照/身份证明",
						value: "IdCardOfAoMen",
					},
					{
						label: "台湾居民来往大陆通行证",
						value: "IdCardOfTaiwan",
					},
					{
						label: "外国人护照",
						value: "Passport",
					},
					{
						label: "警号",
						value: "PoliceNo",
					}
        ],
        faceImage: '',
        isDev: true,
        timer: null,
        headPhoto: ''
      };
    },
    computed: {},
    mounted() {
        console.log("🚀 ~ mounted ~ this.$route.query:", this.$route.query);
        const { domainId, areaCode, isDev, token, headPhoto } = this.$route.query;
        this.domainId = domainId;
        this.areaCode = areaCode;
        // this.isDev = isDev === "false" ? false : true;
        this.isDev = false;
        localStorage.setItem("__isDev__", isDev);
        this.token = token;
        if(headPhoto && headPhoto !== 'undefined'){
            if(headPhoto.indexOf('http')==-1){
                const cdnFileUrl = this.isDev
                  ? "https://v5qy.te.baibaodun.com.cn"
                  : "https://v5qy.baibaodun.cn";
                  this.headPhoto = cdnFileUrl + '/obpm' + headPhoto;
            }else{
                this.headPhoto = headPhoto;	
            }
        }
      // this.timer = setInterval(()=>{
      //   this.getFaceImage();
      // },500)
    },
    beforeDestroy () {
      //
    },
    methods: {
      getFaceImage() {
        // document.addEventListener('UniAppJSBridgeReady', function() {
          const { verify_token } = this.$route.query;
          if(verify_token){
            clearInterval(this.timer);
            getBaiduResultSimple({verify_token: verify_token}).then(res=>{
              if(res.success){
                this.faceImage = res?.result?.image;
                uni.postMessage({
                  data: {
                      faceImage: res?.result?.image,
                      msg: '身份核验成功'
                  }
                });
                wx.miniProgram.postMessage({ 
                    data: { 
                      faceImage: res?.result?.image,
                      msg: '身份核验成功'
                    } 
                });
              }
            });
            // getBaiduFaceDetail({verify_token: verify_token}).then(res=>{
            //   console.log("🚀 ~ getBaiduFaceDetail ~ res:", res);
            // });
          }
        // })
      },
      faceCollection() {
        this.idCardType = 'face';
        this.handleClose();
        this.$refs.faceFile.click();
        // wx.miniProgram.postMessage({ 
        //     data: { faceImage: 99999 } 
        // });

        // getBaiduFace({plan_id: '22574'}).then(async res => {
        //   if(res.success) {
        //     const { verify_token } = res.result;
        //     location.href = `https://brain.baidu.com/face/print/?token=${verify_token}&successUrl=${encodeURIComponent(`https://v5qy.te.baibaodun.com.cn/static/signon/access/#/face?verify_token=${verify_token}`)}&failedUrl=${encodeURIComponent(`https://v5qy.te.baibaodun.com.cn/static/signon/access/#/face?verify_token=${verify_token}`)}`;
        //   }
        // });
      },
      takeIdCard(e) {
        this.handleClose();
        this.credentialType = e.value;
        this.typeLabel = e.label;
      },
      selectCardType() {
        this.cardTypeShow = true;
      },
      toCollect(type) {
        // this.drawer = true;
        this.idCardType = type;
        this.takeFile();
      },
      handleClose(e) {
        this.drawer = false;
        this.cardTypeShow = false;
      },
      takeCamera() {
        this.handleClose();
        const video = document.getElementById('videoCamera');  
        const canvas = document.getElementById('canvasCamera');  
        const context = canvas.getContext('2d');  
        context.drawImage(video, 0, 0, this.videoWidth, this.videoHeight);  
        this.imgSrc = canvas.toDataURL('image/png');
      },
      takeFile() {
        this.handleClose();
        this.$refs.leftFile.click();
      },
      // 华为云静默活体检测
      async getHwLiveFace(url) {
        try{
            const res = await gethwtoken();
            const facwRes = hwLiveDetectFace({"image_url": url,"attributes": "人脸属性"}, 
            {"X-Auth-Token": res["x-subject-token"]})
            console.log('facwRes: ', facwRes);
        }catch{
            //
        }
      },
      async getFile(e) {
        let file = e.target.files[0];
        if(this.idCardType === 'face'){ // 人脸采集
            uploadFile({file: file}, {
                onSuccess: (data) => {
                    this.obsFilePath = data;
                    // await this.getHwLiveFace(data);
                    this.faceCollectLabel = '已采集';
                },
                context: this,
                domainId: this.domainId
            });
        }else{ // 身份证采集
            const loading = this.$loading({
                lock: true,
                text: '身份证识别中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                customClass: 'createLoading',  // 局部class名称
            });
            try{
                // this.uploadFileToV5(file);
                uploadFile({file: file}, {
                    onSuccess: async (data) => {
                        console.log('uploadUrl: ', data);
                        const res = await this.fileChange(file);
                        loading.close();
                        if(res){
                            if(this.idCardType === 'front'){
                              this.frontPhoto = data;
                            }else{
                              this.reversePhoto = data;
                            }
                        }else{
                          this.$message.error('身份证识别失败，请重新上传清晰图片！');
                        }
                    },
                    context: this,
                    domainId: this.domainId
                });
            }catch{
                loading.close();
            }
        }
        this.$refs.leftFile.value = '';
      },
      // 上传文件到v5
      uploadFileToV5(file) {
        const params = {
          filePath: file,
          name: "file",
        }
        // let params = new FormData();
        // formData.append('filePath', file);
        // formData.append('name', 'file');
        uploadFileToV5Api(params).then(res => {
          if (res.statusCode == 200) {
            let data = res.data && JSON.parse(res.data);
            if(data.status == 200){
              // let fullFile = "https://v5qy.te.baibaodun.com.cn" + data.data;
              // resolve({
              //   file: data.data, //相对文件地址
              //   fullFile, //完整文件地址
              // });
            }
          }
        }).catch(err => {
        //   console.log("🚀 ~ uploadFileToV5Api ~ err:", err)
          
        })
      },
      // 把base64位身份证头像生成白底照片在上传v5
        getWhitePortraitPhoto(file) {
            return new Promise((resolve, reject) => {
                uploadBase64ImgToV5Api({bStream: file}).then((res) => {
                    console.log("base64位图片",res)
                    if (res.status == 200) {
                        if (res.data) {
                            if (res.data.indexOf("/uploads") > -1) {
                                let fullFile, file;
                                if (!this.isDev) {
                                fullFile = res.data.replace(
                                    "/uploads",
                                    "https://02obs.baibaodun.cn"
                                );
                                file = res.data.replace(
                                    "/uploads",
                                    "https://02obs.baibaodun.cn"
                                );
                                } else {
                                fullFile = `https://v5qy.te.baibaodun.com.cn/obpm/${res.data}`;
                                file = res.data;
                                }
                                return resolve({
                                file: file,
                                fullFile,
                                });
                            }
                        }
                    }
                    this.$message.error('网络异常,请重试');
                }).catch((err) => {
                    this.$message.error('身份证采集失败，请重试');
                });
            });
        },
      // 身份证OCR识别
      fileChange(file){
        return new Promise((resolve, reject) => {
            const _this = this;
            const reader = new FileReader();
            reader.readAsDataURL(file);//参数为上传的文件对象 传值进去就会触发以下onload方法
            reader.onload = function (e) {
              const imgUrl = e.target.result;
              // e.target.result为转换成的base64编码
              const url = e.target.result.split(',')[1];
              getBaiduIdcard({image: url, id_card_side: _this.idCardType, detect_photo: true}).then(async res => {
                if(res.image_status === 'normal'){
                    const { words_result, photo } = res;
                    if(_this.idCardType === 'front'){
                        if(photo){ //有采集到身份证头像才显示
                            try{
                                _this.portrait = "data:image/jpg;base64," + photo;
                                //采集到身份证的头像，百度识别接口返回1寸白底照片
                                if(!_this.headPhoto){
                                    const {file, fullFile} = await _this.getWhitePortraitPhoto(_this.portrait);
                                    _this.headPhoto = fullFile;
                                    console.log('file, fullFile: ', file, fullFile);
                                }
                                _this.userIdcardInfo.name = words_result['姓名'].words;
                                _this.userIdcardInfo.idCardNum = words_result['公民身份号码'].words;
                                _this.userIdcardInfo.address = words_result["住址"].words;
                                _this.rightSideUrl = imgUrl;
                                resolve(true);
                            }catch{
                                resolve(false);
                            }
                        }else{
                            resolve(false);
                        }
                    }else{
                        resolve(true);
                        let endTime = words_result["失效日期"].words;
                        let endDate = "";
                        if (isNaN(endTime)) {
                            //如果时间为长期，传null
                            endDate = null;
                        } else {
                            endDate =
                                endTime.slice(0, 4) +
                                "-" +
                                endTime.slice(4, 6) +
                                "-" +
                                endTime.slice(-2);
                        }
                        let beginTime = words_result["签发日期"].words;
                        let beginDate = "";
                        if (isNaN(beginTime)) {
                            beginDate = null;
                        } else {
                            beginDate =
                                beginTime.slice(0, 4) +
                                "-" +
                                beginTime.slice(4, 6) +
                                "-" +
                                beginTime.slice(-2);
                        }
                        if (endDate) {
                            let _endDate = new Date(endDate).getTime();
                            let today = new Date().getTime();
                            if (today > _endDate) {
                                _this.$message.error('该证件已过期，请证件补办后再提交核验!');
                            }
                        }
                        _this.userIdcardInfo.validDateFrom = beginDate;
                        _this.userIdcardInfo.validDateTo = endDate;
                        _this.reverseSideUrl = imgUrl;
                    }
                }else{
                  _this.$message.error('身份证识别失败，请重新上传清晰图片！');
                  reject();
                }
              }).catch(err=>{
                reject(err);
              });
            }
        })
      },
      // 人脸比对
      matchFace() {
        return new Promise((resolve, reject) => {
          const params = {
              oneImg: this.headPhoto, //身份证生成的---头像走百度生成一寸白底照片 obs地址
              twoImg: this.obsFilePath, //活体图片obs地址
            };
        console.log('params:-人脸比对参数 ', params);
          // 公共服务
          const commonBaseUrl = this.isDev
            ? "https://identify.test.bcxin.com.cn" 
            : "https://identify.qiye.baibaodun.com.cn:14433";
          matchFaceApi(params, commonBaseUrl).then(res => {
            console.log("🚀 ~ matchFaceApi ~ res:", res)
            if (res.retType == 0) {
                let faceMatch = res.data.result;
                if (faceMatch == 1) {
                  return resolve(true)                     
                }
            }
            resolve(false)
          }).catch(err => {
            console.log("🚀 ~ matchFaceApi ~ err:", err)
            reject(false);
          })
        });
      },
      async toFace() {
        if(!this.typeLabel){
          return this.$message.error('请选择证件类型');
        }
        if(!this.rightSideUrl){
          return this.$message.error('请先采集身份证人面像');
        }
        if(!this.userIdcardInfo.address){
          return this.$message.error('身份证人面信息识别失败，请重新上传');
        }
        if(!this.userIdcardInfo.validDateFrom){
          return this.$message.error('请先采集身份证国徽面');
        }
        if(this.faceCollectLabel === '未采集'){
          return this.$message.error('请先采集人脸信息');
        }
        if(!this.phone){
          return this.$message.error('请输入手机号');
        }
        if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.phone)) {
          return this.$message.error('请输入正确的手机号');
        }
        const res = await this.matchFace();
        if (!res) {
          return this.$message.error('人脸比对失败');
        }
        const params = {
          address: this.userIdcardInfo.address,
          areaCode: this.areaCode,
          certificateImage: this.obsFilePath,
          credentialType: this.credentialType,
          loginFrom: "BBD",
          name: this.userIdcardInfo.name,
          number: this.userIdcardInfo.idCardNum,
          phone: this.phone,
          frontPhoto: this.frontPhoto,
          headPhoto: this.headPhoto,
          reversePhoto: this.reversePhoto,
          validDateFrom: this.userIdcardInfo.validDateFrom,
          validDateTo: this.userIdcardInfo.validDateTo,
          // wgtVersion: "1.0.0"
        }
        const headers = {
          Authorization: "Bearer " + this.token,
        }
        confirmCheckStatus(params, headers).then(res => {
          console.log("🚀 ~ confirmCheckStatus ~ res:", res)
          this.$message.success('核验成功');
          wx.miniProgram.postMessage({ 
              data: { 
                msg: '身份核验成功',
                cgiToken: res.data.cgiToken,
                token: res.data.token
              } 
          });
          wx.miniProgram.navigateBack();
        }).catch(err => {
          // this.$message.error('核验失败！');
        })
      }
    }
  }
</script>
  
<style lang="scss" scoped>
.createLoading{
    .el-loading-spinner i{
        color: #00D583;
    }
    .el-loading-text{
        color: #00D583;
    }
}
::v-deep .el-input .el-input__inner{
    text-align: right;
    padding: 0%;
    border: none;
}
.container{
  padding-bottom: 32px;
  .header{
    padding-top: 72px;
    text-align: center;
    font-size: 24px;
    color: #fff;
    height: 140px;
    background: linear-gradient( 180deg, #00D583 0%, #00D583 69%, rgba(132,221,41,0) 100%);
  }
  .content{
    background: #fff;
    margin: -60px 16px 0;
    border-radius: 8px;
    padding: 6px 0;
  }
  .item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px 8px 12px;
    background: url('@/assets/images/icon-rectangle.png') right no-repeat;
    background-size: 8px;
    background-position: right 10px bottom 10px;
    .value{
      margin-right: 8px;
    }
  }
  .txt{
    span{
      color: #FD3F2E;
      margin-right: 6px;
    }
  }
  .item-verify-side{
    padding: 12px 16px 8px 12px;
    text-align: left;
    .collect-box{
      text-align: center;
      padding-top: 25px;
      border-radius: 8px;
      background-color: #F8F9FB;
      margin: 12px 10px 0;
      &-image{
        height: 111px;
        width: 194px;
        margin-bottom: 20px;
      }
      &-btn{
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
        height: 38px;
        line-height: 38px;
        color: #fff;
        text-align: center;
        background: #0BD87E;
      }
    }
  }
  .collect-item{
    padding: 12px 16px 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .phone{
      width: 60%;
    }
    .default{
      color: #999999;
    }
  }
  .verify-btn{
    border-radius: 8px;
    height: 38px;
    line-height: 38px;
    color: #fff;
    text-align: center;
    background: #0BD87E;
    margin: 32px 24px 0;
  }
}
.camera-box{
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS<11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容iOS>= 11.2 */
}
.camera-box-item{
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #f8f8f8;
}
::v-deep .drawerStyle{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 102px !important;
  padding: 0 16px;
}
::v-deep .cardTypeStyle{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 204px !important;
  padding: 0 16px;
}
</style>
  